import * as React from 'react';

const Download24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.999 2a.75.75 0 0 1 .75.75v12.5l5.72-5.53a.75.75 0 1 1 1.06 1.06l-7.005 7.005a.747.747 0 0 1-1.055-.004l-7-7a.75.75 0 0 1 1.06-1.061l5.72 5.53V2.75a.75.75 0 0 1 .75-.75M3.75 20.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
  }
));
Download24.Size = 24;
Download24.Title = "Download";

export { Download24 as default };
